export const baseTheme = {
  colors: {
    primary: {
      main: '#5C0087',
      ultraDark: '#3C1053',
      dark: '#5C0087',
      toku: '#7F00B2',
      light1: '#A94BE0',
      light2: '#C297DB',
      light3: '#E3D2ED',
      light4: '#EDE8F0',
      light5: '#F7F3FA',
    },
    gray: {
      main: '#373737',
      dark2: '#545454',
      dark3: '#707070',
      medium1: '#8D8D8D',
      medium2: '#A9A9A9',
      light1: '#C6C6C6',
      light2: '#E2E2E2',
      light3: '#F2F2F2',
      light4: '#FAFAFA',
    },
    error: '#B72E29',
    success: '#408645',
    warning: '#D06B35',
    inProcess: '#FFB038',
    inProcessDark: '#A37500',
    info: '#3070DD',
    background: '#F5F5F5',
  },
  typography: {
    color: '#373737',
    fontFamily: '"Poppins", sans-serif',
    buttonTextColor: '#FFFFFF',
    fontWeight: {
      bold: 700,
      semibold: 600,
      medium: 500,
      regular: 400,
    },
  },
  button: {
    borderRadius: '0.5rem',
  },
  input: {
    borderRadius: '0.375rem',
  },
  spacing: '4px',
  breakpoints: {
    mobile: 0,
    desktop: 769,
  },
  iconSet: 'heroicons',
  parseMarkdown: false,
};
